import Utils from '../util/Utils.jsx';
import { getOfflineDatasets } from './db.js';
import { getDevMockDatasets, shouldUseDevMockProjects, withDevTimeout } from '../util/devMockProjects.js';

export const getDatasets = dispatch => {
	if (shouldUseDevMockProjects()) {
		return withDevTimeout(Utils.ajaxAsync('getDatasets', {}, null, { suppressErrorAlert: true }))
			.then(result => {
				if (result.success && result.datasets && Object.keys(result.datasets).length) {
					return result;
				}
				return { success: true, datasets: getDevMockDatasets() };
			})
			.catch(() => ({ success: true, datasets: getDevMockDatasets() }));
	}

	if (Utils.isOnline()) {
		return Utils.ajaxAsync('getDatasets', {}, dispatch).then(result => {
			if (result && result.success) {
				return result;
			}
			return Promise.reject(result || { success: false, error: 'getDatasets failed' });
		});
	}
	return getOfflineDatasets(dispatch);
};
